import dedent from 'dedent';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'read-remote-file' as const;

const argumentZod = z.object({
  path: z
    .string()
    .describe(
      'The path of the file to read, relative to the project root (e.g. "tsconfig.json", "./src/index.tsx")'
    ),
  intent: z
    .string()
    .optional()
    .describe(
      'A short, human-readable summary of why you are reading this file (e.g. "Reading component source code", "Checking capability boundaries"). Shown to the user in the UI.'
    ),
});

export const readRemoteFileTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Read remote file',
  prettyErrors: {
    fallback: 'Unable to read file.',
    patterns: [
      {
        match: 'not found',
        message: 'File not found.',
      },
      {
        match: 'not a text file',
        message: 'File is not a text file.',
      },
    ],
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Reads the contents of a file from the code component sandbox environment. The file path is relative to the project root.

      Use this tool to examine project configuration, source files, or any other text file in the sandbox. This is especially useful for:
      - Reading source code files to understand code structure
      - Understanding project dependencies and build configuration

      Only files containing text can be read by this tool. Binary files are not supported.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteSymbol', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
  timeout: 15000,
});
